import React from 'react'
import "./SearchStatsSection.css"

const SearchStatsSection = () => {


// create a search stats array with title and number
const searchStats = [
    {
        title: "Beach", number: "4.8MM"
    },
    {
        title: "Resort", number: "3.2MM"
    },
    {
        title: "Spa", number: "1.7MM"
    },
    {
        title: "Lake", number: "1.5MM"
    },
    {
        title: "Tour", number: "1.5MM"
    },
    {
        title: "Villa", number: "1.4MM"
    },
    {
        title: "Palace", number: "1.3MM"
    },
    {
        title: "Island", number: "1.1MM"
    },
    {
        title: "Pizzeria", number: "1MM"
    },
    {
        title: "Camping", number: "737K"
    },
    {
        title: "Dreams", number: "517K"
    },
]

//MAP THROUGH THE ARRAY AND DISPLAY THE DATA
const renderSearchStats = () => {
    return searchStats.map((stat, index) => {
            return (
                <div className="search-pill" key={index}>
                    <span className="search-stats-title">{stat.title}</span>
                    <span className="search-stats-number">{stat.number}</span>
                </div>
            )
        })
  };








  return (
    <div className="trip-background-moss uk-section uk-section-large uk-height-viewport uk-flex uk-flex-center uk-flex-middle top-z" >
	            <div className="uk-container uk-container-medium uk-padding uk-flex uk-flex-center"> 

                        <div className="tm-grid-expand uk-child-width-1-1 uk-grid uk-grid-stack" uk-grid="">
                                <div className="uk-width-1-1">

		<div className="uk-margin-auto uk-animation-slide-bottom-medium">

                <div className="" uk-scrollspy-class="">
                                <div className="uk-text-center trip-white uk-margin-large-bottom trip-heading-display trip-ultra">  
                                We compiled our data and, <br className='uk-visible@l'/>in 2022, travelers came to us in search of big ideas. 
                                  
                                </div>
                </div>

                <div className='white-card uk-container-small uk-margin-auto' uk-scrollspy-class="">

                <div className='uk-flex uk-flex-middle uk-transform-origin-top-center search-home-button uk-animation-slide-left-medium' >
                       <span uk-icon="icon: search" className='uk-margin-right'></span>  Where to?
                </div>
                   <hr className='uk-hr uk-animation-slide-left-medium' />

                   <div className="uk-flex uk-flex-wrap search-pill-container" uk-scrollspy="cls: uk-animation-slide-left-small; target: .search-pill; delay: 150; repeat: true">
                          {renderSearchStats()}
                    </div>

                </div>

		</div>




</div>
</div>

    </div>
</div>
  )
}

export default SearchStatsSection